import {inject, Injectable} from "@angular/core";
import {CanDeactivate, GuardResult, MaybeAsync, Router} from "@angular/router";
import {DashboardStore} from "@widgets/dashboard";
import {WidgetConstructorPageComponent} from "../ui/widget-constructor-page/widget-constructor-page.component";

@Injectable({providedIn: "root"})
export class CanDashboardPageDeactivate implements CanDeactivate<WidgetConstructorPageComponent> {
    store = inject(DashboardStore);
    router = inject(Router);

    canDeactivate(): MaybeAsync<GuardResult> {
        if (this.store.editMode()) {
            const answer = confirm("У вас есть несохраненные изменения. Вы уверены, что хотите уйти?");
            if (answer) this.store.toggleEditMode();

            return answer;
        }

        return true;
    }
}
